import React from "react";
import {motion, AnimatePresence} from "framer-motion";

const PageWrapper = ({children}) => {
  const transitionOptions = {
    initial: {
      opacity: 0
    },
    enter: {
      opacity: 1,
      transition: {
        duration: 0.5,
        delay: 0.5,
        when: "beforeChildren"
      }
    },
    exit: {
      opacity: 0,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        style={{"position": "absolute", "top": "0", "left": "0", "right": "0"}}
        key={Math.random()}
        variants={transitionOptions}
        initial="initial"
        animate="enter"
        exit="exit"
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default PageWrapper;